
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    count: [],
    id: [],
};

const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAdminId: (state, action) => {
            const index = action.payload;
            const isChecked = state.id.includes(index);
            if (isChecked) {
                // Remove the index if it's already in the array (unchecking)
                state.id = state.id.filter(i => i !== index);
            } else {
                // Add the index if it's not in the array (checking)
                state.id.push(index);
            }
        },
        setCount: (state, action) => {
            const { key, value } = action.payload;
            state.count[key] = value;
        },
        clearAll: (state, action) => {
            state.count = []
            state.id = []
        }
    },
});

export const {
    setAdminId,setCount, clearAll
} = adminSlice.actions;
export default adminSlice.reducer;
